import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";

const { TextArea } = Input;

const NdrReattemptModal = ({
  showReattemptModal,
  setShowReattemptModal,
  selectedOrder,
  reattemptOrder,
  reattempting,
}) => {
  const [form] = Form.useForm();

  // Helper to get tomorrow's date in YYYY-MM-DD format
  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (selectedOrder) {
      const fullAddress = [
        selectedOrder?.BillingAddress?.AddressLine1,
        selectedOrder?.BillingAddress?.AddressLine2,
        selectedOrder?.BillingAddress?.City,
        selectedOrder?.BillingAddress?.State,
        selectedOrder?.BillingAddress?.Pincode,
      ]
        .filter(Boolean)
        .join(", ");

      form.setFieldsValue({
        address: fullAddress,
        phone: selectedOrder?.BillingAddress?.Contact || "",
        remarks: "Reattempt order",
      });
    }
  }, [selectedOrder, form]);

  const handleSubmit = async (values) => {
    if (!selectedOrder) return;

    // Check if ndrId exists
    if (!selectedOrder?.ndrId) {
      console.error("NDR ID not found for this order");
      alert("NDR ID not available for this order");
      return;
    }

    try {
      const payload = {
        ndrId: selectedOrder.ndrId, // FIXED: Use ndrId from order
        reattemptDate: getTomorrowDate(),
        remarks: values.remarks || "reattempt",
        // Optional: if backend needs these
        address: values.address,
        phone: values.phone,
      };

      await reattemptOrder(payload);
      setShowReattemptModal(false);
    } catch (error) {
      console.error("Reattempt failed:", error);
    }
  };

  return (
    <Modal
      title="NDR Reattempt Order"
      open={showReattemptModal}
      onCancel={() => setShowReattemptModal(false)}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        {/* Display NDR ID for reference */}
        {selectedOrder?.ndrId && (
          <div className="mb-4 p-3 bg-blue-50 rounded">
            <p className="text-sm text-gray-700">
              <strong>NDR ID:</strong> {selectedOrder.ndrId}
            </p>
            <p className="text-sm text-gray-700">
              <strong>Order Number:</strong> {selectedOrder.order_number}
            </p>
          </div>
        )}

        <Form.Item
          name="address"
          label="Address"
          rules={[{ required: true, message: "Please enter address" }]}
        >
          <TextArea rows={3} placeholder="Enter delivery address" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Contact Number"
          rules={[
            { required: true, message: "Please enter phone number" },
            {
              pattern: /^[0-9]{10}$/,
              message: "Please enter a valid 10-digit phone number",
            },
          ]}
        >
          <Input placeholder="Enter 10-digit phone number" />
        </Form.Item>

        <Form.Item 
          name="remarks" 
          label="Remarks"
          rules={[{ required: true, message: "Please enter remarks" }]}
        >
          <Input placeholder="Enter reattempt remarks" />
        </Form.Item>

        <div className="flex justify-end space-x-2 mt-4">
          <button
            type="button"
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
            onClick={() => setShowReattemptModal(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={reattempting}
          >
            {reattempting ? "Submitting..." : "Submit Reattempt"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default NdrReattemptModal;